import { useMap } from 'react-map-gl/maplibre';
import { useEffect, useCallback, useRef } from 'react';
import { throttle } from 'lodash';
import { useMapSync } from './map_syncro';

export default function MapSynchronizer() {
  const { current: map } = useMap();
  const { mapState, updateMapState } = useMapSync();
  const isInternalUpdate = useRef(false);

  // 1) Empuja centro+zoom al contexto con throttle de 60 ms
  const syncState = useCallback(throttle(() => {
    if (isInternalUpdate.current) {
        isInternalUpdate.current = false;
        return;
    }
    const center = map.getCenter();
    updateMapState({
        center: [center.lat, center.lng],
        zoom: map.getZoom()
    });
  }, 60), [map, updateMapState]);

  // 2) Escucha MOVE y ZOOM
  useEffect(() => {
    if (!map) return;
    map.on('move', syncState);
    map.on('zoom', syncState);
    return () => {
      if (map) {
        map.off('move', syncState);
        map.off('zoom', syncState);
      }
    };
  }, [map, syncState]);

  // 3) Cuando cambie el contexto, actualizar el mapa
  useEffect(() => {
    if (!map || !mapState) return;
    const [lat, lng] = mapState.center;
    const z = mapState.zoom;

    const currentCenter = map.getCenter();
    const currentZoom = map.getZoom();

    if (
      Math.abs(currentZoom - z) > 0.001 ||
      Math.abs(currentCenter.lat - lat) > 0.0001 ||
      Math.abs(currentCenter.lng - lng) > 0.0001
    ) {
      isInternalUpdate.current = true;
      map.jumpTo({
        center: [lng, lat],
        zoom: z
      });
    }
  }, [mapState, map]);

  return null;
}

